import HomeIcon from 'src/assets/svg/sidebar-icons/home'
import AccountIcon from 'src/assets/svg/sidebar-icons/account'
import InvestmentIcon from 'src/assets/svg/sidebar-icons/investment'
import BorrowIcon from 'src/assets/svg/sidebar-icons/borrow'
import InsightIcon from 'src/assets/svg/sidebar-icons/insight'
import LifestyleIcon from 'src/assets/svg/sidebar-icons/lifestyle'
import SupportIcon from 'src/assets/svg/sidebar-icons/support'
import SettingsIcon from 'src/assets/svg/sidebar-icons/settings'
import CBPIcon from 'src/assets/svg/cbp-icon'

export const sideBarData = [
    {
        title: 'Home',
        path: '/dashboard/home',
        icon: (isHover: boolean) => <HomeIcon isHover={isHover}/>
    },
    {
        title: 'Account',
        path: '/dashboard/account',
        icon: (isHover: boolean) => <AccountIcon isHover={isHover}/>
    },
    // {
    //     title: 'Investment',
    //     path: '/dashboard/investment',
    //     icon: (isHover: boolean) => <InvestmentIcon isHover={isHover}/>
    // },
    {
        title: 'Borrow',
        path: '/dashboard/borrow',
        icon: (isHover: boolean) => <BorrowIcon isHover={isHover}/>
    },
    {
        title: 'Insight',
        path: '/dashboard/insight',
        icon: (isHover: boolean) => <InsightIcon isHover={isHover}/>
    },
    // {
    //     title: 'Cbp',
    //     path: '/dashboard/cbp',
    //     icon: (isHover: boolean) => <CBPIcon isHover={isHover}/>
    // },
    // {
    //     title: 'Lifestyle',
    //     path: '/dashboard/lifestyle',
    //     icon: (isHover: boolean) => <LifestyleIcon isHover={isHover}/>
    // },
    {
        title: 'Support',
        path: '/dashboard/support',
        icon: (isHover: boolean) => <SupportIcon isHover={isHover}/>
    },
    {
        title: 'Settings',
        path: '/dashboard/settings',
        icon: (isHover: boolean) => <SettingsIcon isHover={isHover}/>
    }
]